module.exports = __webpack_public_path__ + "img/21-LORCR-0741-Cerave-LRP-Sun-Heroes-Program-Rebranded-Curriculum-V6.bbdeb052.png";